<template>
  <button v-if="isExpanded" :class="state" :aria-label="triggerLabel" @click.prevent="toggle">
    <svg height="24" width="24" viewBox="0 0 24 24">
      <use xlink:href="#icon-close" />
    </svg>
  </button>
  <button v-else :class="state" :aria-label="triggerLabel" @click.prevent="toggle">
    <svg height="24" width="24" viewBox="0 0 24 24">
      <use xlink:href="#icon-search" />
    </svg>
  </button>
</template>
<script>
export default {
  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    triggerLabel() {
      return `${this.isExpanded ? "Hide" : "Show"} search`;
    },
    state() {
      return `${this.isExpanded ? "btn btn--is-active" : "btn"}`;
    },
  },
  methods: {
    toggle() {
      this.$emit("toggle");
    },
  },
};
</script>
